import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { More } from '@/components/More';

export const Route = createFileRoute('/_auth/more')({
  component: MoreRoute,
});

function MoreRoute() {
  return <More />;
}
